import { render, staticRenderFns } from "./KkgNotification.vue?vue&type=template&id=7b3c05ef&scoped=true"
import script from "./KkgNotification.vue?vue&type=script&lang=js"
export * from "./KkgNotification.vue?vue&type=script&lang=js"
import style0 from "./KkgNotification.vue?vue&type=style&index=0&id=7b3c05ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c05ef",
  null
  
)

export default component.exports